import React from 'react';
import BasePage from './BasePage';
import '../styles/pages.css';

export default function Manager() {
  const services = [
    { icon: '📦', title: 'Отслеживание груза', description: 'Реал-тайм информация о статусе посылки' },
    { icon: '💰', title: 'Консультация по расчету', description: 'Помощь с расчетом стоимости доставки' },
    { icon: '📋', title: 'Оформление документов', description: 'Помощь в оформлении таможенных документов' },
    { icon: '🚚', title: 'Логистические решения', description: 'Индивидуальные предложения для крупных грузов' },
  ];

  const faqItems = [
    {
      question: 'Сколько времени занимает доставка?',
      answer: 'Срок доставки товаров из Китая в Казахстан составляет 8–15 дней. Счёт дней начинается с момента отправки товара со склада в Китае. В случае форс-мажора, праздников или работы таможни, сроки доставки могут измениться. Карго не несёт ответственность за задержки, вызванные указанными обстоятельствами.'
    },
    {
      question: 'Как работает страхование груза?',
      answer: 'Клиент может оформить страховку при отправке через Карго. Стоимость страховки: 1% от стоимости груза (минимум 2 500 ₸). Страховка покрывает только заявленную стоимость товара по скриншоту. Если груз не застрахован, Карго не несёт ответственности за повреждение, потерю или недостачу. Отказаться от страховки можно только до отправки груза со склада.'
    },
    {
      question: 'Какие документы требуются?',
      answer: 'Требуется паспорт и таможенный декларат. Наш менеджер поможет вам с оформлением всех необходимых документов. Для хрупких товаров требуется деревянная обрешётка (стоимость 10 USD). Клиент обязан заранее уведомить карго о хрупком товаре.'
    },
    {
      question: 'Какова ответственность компании?',
      answer: 'Компания отвечает только за товары, которые поступили на склад и отображены на сайте. Ответственность за сохранность груза несёт только филиал Карго, который принял товар. Если товар забирает третье лицо по доверенности, все риски переходят на клиента. Компания не несёт ответственность за содержимое посылок и претензии к интернет-магазинам.'
    },
    {
      question: 'Можно ли отменить или вернуть заказ?',
      answer: 'Отмена возможна только до выкупа товара у продавца. После выкупа, поступления на склад или отправки в Казахстан отмена и возврат денежных средств категорически невозможны. По прибытию товара в Казахстан отказ от товара не допускается ни при каких обстоятельствах.'
    },
    {
      question: 'Как защищена моя личная информация?',
      answer: 'Карго обеспечивает сохранность всей личной информации клиента. Карго не раскрывает личные данные третьим лицам, за исключением случаев, необходимых для исполнения обязательств по доставке товара. Карго не раскрывает содержимое заказов и не ведёт учёт количества товаров.'
    }
  ];

  return (
    <BasePage title="Менеджер">
      <div className="manager-page-container">

        {/* Services Section */}
        <div className="services-section">
          <h3>Услуги менеджера</h3>
          <div className="services-grid">
            {services.map((service, idx) => (
              <div key={idx} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h4>{service.title}</h4>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <h3>❓ Часто задаваемые вопросы</h3>
          <div className="faq-container">
            {faqItems.map((item, idx) => (
              <details key={idx} className="faq-item">
                <summary className="faq-question">{item.question}</summary>
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>

        {/* Schedule Section */}
        <div className="schedule-section">
          <h3>⏰ График работы менеджера</h3>
          <div className="schedule-content">
            <p><strong>📞 Телефон / WhatsApp:</strong> +7 702 778 17 34</p>
            <p><strong>✉️ Email:</strong> araika_ukg@mail.ru</p>
            
            <div className="schedule-table">
              <div className="schedule-row">
                <div className="day">Понедельник</div>
                <div className="time">Выходной</div>
              </div>
              <div className="schedule-row">
                <div className="day">Вторник–Пятница</div>
                <div className="time">19:30 – 22:30</div>
              </div>
              <div className="schedule-row">
                <div className="day">Суббота–Воскресенье</div>
                <div className="time">13:00 – 17:00</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </BasePage>
  );
}
